import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { DocumentFrame } from '../common/DocumentPreviewModal';
import './DrawingPairModal.css';

/** Imagen de un análisis, pedida con el token (el <img> a pelo no lo lleva).
 *  Con `page` se renderiza esa página (lento en ficheros MCP: descarga y render); sin ella se sirve
 *  la vista previa ya guardada, que es inmediata. */
export const AuthImage = ({ analysisHash, page, alt, className }) => {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let url = null;
    let vivo = true;
    const pagina = page ? `?page=${page}` : '';
    fetch(`${process.env.REACT_APP_API_URL}/v1/analyses/${analysisHash}/image${pagina}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then(res => (res.ok ? res.blob() : Promise.reject(res.status)))
      .then(blob => { if (vivo) { url = URL.createObjectURL(blob); setSrc(url); } })
      .catch(() => {});
    return () => { vivo = false; if (url) URL.revokeObjectURL(url); };
  }, [analysisHash, page]);

  if (!src) return <div className={`auth-image-vacia ${className || ''}`}>…</div>;
  return <img src={src} alt={alt} className={className} />;
};

/** LAKPED-21: el plano subido y el parecido, uno al lado del otro, para decidir si son el mismo.
 *  Van los documentos enteros (Paula quería poder pasar páginas), cada uno abierto por la página que casó. */
const DrawingPairModal = ({ izquierda, derecha, onClose }) => {
  useEffect(() => {
    const cerrarConEscape = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', cerrarConEscape);
    return () => window.removeEventListener('keydown', cerrarConEscape);
  }, [onClose]);

  const lado = ({ titulo, analysisHash, page }) => (
    <figure className="drawing-pair-lado">
      <figcaption>{titulo}</figcaption>
      <DocumentFrame analysisHash={analysisHash} filename={titulo} page={page} className="drawing-pair-visor" />
    </figure>
  );

  return createPortal(
    <div className="drawing-pair" onClick={onClose}>
      <div className="drawing-pair-cuerpo" onClick={(e) => e.stopPropagation()}>
        <div className="drawing-pair-barra">
          <span>¿Es el mismo plano?</span>
          <button type="button" className="drawing-pair-cerrar" onClick={onClose}>Cerrar</button>
        </div>
        <div className="drawing-pair-columnas">
          {lado(izquierda)}
          {lado(derecha)}
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default DrawingPairModal;
